
import { useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';
import { Product } from '@/components/product/ProductCard';

export const useProductClicks = () => {
  const trackProductClick = useCallback(async (product: Product) => {
    try {
      const { error } = await supabase
        .from('product_clicks')
        .insert({
          product_id: product.id,
          product_source: product.source || 'unknown',
          product_name: product.name,
          affiliate_link: product.affiliate_link,
          category: product.category
        });

      if (error) {
        console.error('Error tracking product click:', error);
      }
    } catch (error) {
      console.error('Failed to track product click:', error);
    }
  }, []);

  return { trackProductClick };
};
